import environment from 'environment';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import HttpUtility from '../../utilities/HttpUtility';
import forgotPassModel from '../_model/forgotPassModel';
import EffectUtility from '../../utilities/EffectUtility';

export const forgotPassEffect = {
  forgotPassSet,
  requestError,
};

async function forgotPassSet(payload) {
  const endpoint = environment.api.forgetPassword.replace(payload);
  const response = await HttpUtility.post(endpoint, payload);
  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response;
}

/**
 * This is only to trigger an error api response so we can use it for an example in the AboutPage
 */
async function requestError() {
  const endpoint = environment.api.errorExample;
  const response = await HttpUtility.get(endpoint);

  if (response instanceof HttpErrorResponseModel) {
    return response;
  }
  return response.data;
}
